<template>
  <div>
    <ChildTableSearch :queryForm="queryForm" :isTimeout="isTimeout" @query="queryList" @newBtnFun="openNew">
    </ChildTableSearch>
    <el-table :data="tableData" v-loading="loading" style="width: 100%;" height='calc(100vh - 285px)'>
      <el-table-column width="100" label="注册时间">
        <template v-slot="scope">
          {{scope.row.registerTime ? (parseTime(scope.row.registerTime, '{y}-{m}-{d}')) : '-'}}
        </template>
      </el-table-column>
      <el-table-column prop="childName" width="120" label="患儿姓名">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.childName">
            <span class="link" @click="openDetail(scope.row)">{{scope.row.childName}}</span>
          </TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column      v-if="isHospital==='false'"   width="140"   label="救助医院">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.hospitalName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column label="病种" prop="diseasesNameSet">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.diseasesNameSet"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="quotaType" width="60" label="期次">
        <template slot-scope="scope">
          <span>{{scope.row.quotaType == 0 ? '单次' : '分期'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="出生日期" width="110">
        <template v-slot="scope">
          <span v-if="scope.row.birthday">
            {{scope.row.birthday | convertTime('YYYY-MM-DD')}}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="sexText" width="60" label="性别">
      </el-table-column>
      <el-table-column label="户口所在地">
        <template slot-scope="scope">
          <TableCellWordBreak :content="(scope.row.provinceText || '') + (scope.row.cityText || '')"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="loginAccount" width="120" label="登录手机号">
      </el-table-column>
      <el-table-column prop="idCard" width="170" label="身份证号">
        <template slot-scope="scope">
          {{!scope.row.hasIdNumber?'-':scope.row.idNumber}}
        </template>
      </el-table-column>
      <el-table-column width="100" label="申请状态">
        <template v-slot="scope">
          <span v-if="scope.row.apprStatus == 3" style="color: red;">{{scope.row.apprStatusText}}</span>
          <span v-else>{{scope.row.apprStatusText ? (scope.row.apprStatus == 5 ? '审核中' : scope.row.apprStatusText)  : '-'}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="helpStatusText" width="100" label="注册状态">
        <template v-slot="scope">
          {{scope.row.isTurnHospital == 1 && scope.row.helpStatus == 0 ? '转院' : scope.row.helpStatusText}}
        </template>
      </el-table-column>
      <el-table-column v-if="isTimeout==1 && isRestart" label="操作" width="100">
        <template slot-scope="scope" >
            <el-button type="primary"  plain @click="reuse(scope.row.helpReqId)" size="mini">重启</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pageination
      @sizeChange="handleSizeChange"
      @currentChange="handleCurrentChange"
      :currentPage="queryForm.pageNO"
      :total="total">
    </Pageination>
    <ChildAdd :detailDialog.sync="newDialog" v-if="newDialog" :newForm="newForm" @closeDetail="closeNew" :queryList="queryList"
      @changeChild="queryList" ></ChildAdd>
    <ChildDetail :detailDialog.sync="detailDialog" v-if="detailDialog" :detailType="detailType" :helpReqId="helpReqId"
      @changeChild="queryList" @closeDetail="closeDetail"></ChildDetail>
  </div>
</template>

<script>
  import Pageination from "@/components/business/Pageination";
  import ChildAdd from "./ChildAdd";
  import ChildTableSearch from "./ChildTableSearch";
  import TableCellWordBreak from "@/components/business/TableCellWordBreak"
  import ChildDetail from "./ChildDetail";
  import {
    getDataListByCond,
    parentAccountReuse
  } from "@/util/api";
  export default {
    components: {
      Pageination,
      TableCellWordBreak,
      ChildAdd,
      ChildTableSearch,
      ChildDetail
    },
    props: {
      isTimeout: 0,
      pageType:''
    },
    data() {
      return {
        detailDialog: false,
        detailType: 0,
        isHospital:'false',
        helpReqId: null,
        loading: true,
        queryForm: {
          searchCond: {
            childName: '', //患儿姓名
            diseasesId: "", //病种
            idNumber: "", //身份证号
            province: "", //所在省
            city: "", //所在市
            county: "", //所在区县
            quotaType: '',
            helpStatusList: this.$route.query.isSubmit == 0 ? ['1', '2'] : null,
            apprStatusList: this.$route.query.isSubmit == 0 ? ['0', '4'] : null,
            registerTimeBegin: "", //注册时间（开始）
            registerTimeEnd: "", //注册时间（结束）
            loginAccount: "", //登录账号
            helpStatus: "", //救助状态
            hospitalId: '',
            isTimeout: null, //是否超期
          },
          orderBy: "createAt desc",
          pageNO: 1,
          pageSize: 10
        },
        newDialog: false,
        newForm: {},
        value1: '',
        value2: '',
        tableData: [],
        total: 0,
        isRestart:false // 重启权限
      }
    },
    created() {
      this.isHospital = window.localStorage.getItem("hospAccount")
      this.queryList()
    },
    mounted() {},
    methods: {
      handleSizeChange(val) {
        this.queryForm.pageSize = val

        this.queryList()
      },
      handleCurrentChange(val) {
        this.queryForm.pageNO = val
        this.queryList()
      },
      //重启
      reuse(id) {
        let that = this
        let params = {
          helpReqId: id
        }
        this.$confirm('是否确认重启该账号', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          parentAccountReuse(params).then(res => {
            if (res.msgCode == 200) {
              this.$message({
                showClose: true,
                message: '账号重启成功',
                type: 'success'
              });
              that.queryList()
            } else {
              this.$message({
                showClose: true,
                message: '账号重启失败',
                type: 'error'
              });
            }
          })
        })

      },
      queryList() {
        let param = this.queryForm
        for (var key in param.searchCond) {
          if (!param.searchCond[key]) {
            delete param.searchCond[key]
          }
        }
        param.searchCond['reqMode'] = 1
        if (param.searchCond.helpStatusList) {
          param.searchCond.helpStatus = param.searchCond.helpStatusList.join(',')
        }
        if (param.searchCond.apprStatusList) {
          param.searchCond.apprStatus = param.searchCond.apprStatusList.join(',')
        }
        if (this.pageType == 'second') {
          param.searchCond['isTimeout'] = 1;
        } else {
          param.searchCond['isTimeout'] = null;
        }
        // if(this.$route.query.isSubmit == 0 && this.pageType=='first') {
        //   param.searchCond['isSubmit'] = 0
        //   param.searchCond['isTimeout'] = null;
        // }else{
        //   param.searchCond['isTimeout'] = null;
        // }
        this.loading = true
        getDataListByCond({
          ...param,
          searchCond: {
            ...param.searchCond,
            apprStatus: param.searchCond.apprStatus == 1 ? '1,5' : param.searchCond.apprStatus
          }
        }).then(res => {
          this.tableData = res.responseData.modelData
          this.total = res.responseData.total
          this.loading = false
          //判断是否有重启权限
          res.responseData.modelData.forEach((item,index)=>{
            if(item.isRestartAccount===1){
              this.isRestart=true;
              console.log("重启",this.isRestart)
            }
          })
        })
      },
      openDetail(status) {
        this.detailDialog = true
        this.helpReqId = status.helpReqId
        this.detailType = status.helpStatus
        this.$emit('toDetail', status)
      },
      openNew() {
        this.newForm = {}
        this.newDialog = true
      },
      closeNew() {
        this.newDialog = false
      },
      closeDetail(status) {
        this.detailDialog = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/common/common';

  .screen {
    width: 100%;
    height: auto;
    min-height: 30%;

    .form {
      width: 100%;
    }

    .form-line {
      display: flex;
      align-items: center;
      width: 100%;
      height: 3.125vw;

      .close-form {

        flex-shrink: 0;

        img {
          width: 0.625vw;
          height: 0.521vw;
        }

        span {
          font-size: 12px;
          font-family: PingFangSC;
          font-weight: bold;
          color: #999999;
        }
      }

      .form-item {
        display: flex;
        margin-right: 3.1vw;
        flex-shrink: 1;

        .label {
          display: block;
          width: 60px;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
        }

        input {
          width: 13vw;
          font-size: 12px;
          border: none;
          border-bottom: #B3B3B3 0.052vw solid;
          outline: none;
        }

        select {
          width: 13vw;
          font-size: 12px;
          border: none;
          border-bottom: #B3B3B3 0.052vw solid;
          outline: none;
        }

        /deep/ .el-select .el-input {
          .el-input__inner {
            width: 13vw;
            font-size: 12px;
            border: none;
            border-bottom: #B3B3B3 0.052vw solid;
            outline: none;
            border-radius: 0;
            height: 20px;
            padding: 0;
          }
        }

        /deep/ .el-cascader {
          height: 20px !important;
          line-height: 20px !important;
          width: 13vw;

          .el-input {
            height: 20px !important;
            line-height: 20px !important;
            width: 13vw;
            padding-left: 5px;

            .el-input__inner {
              width: 13vw;
              font-size: 12px;
              border: none;
              border-bottom: #B3B3B3 0.052vw solid;
              outline: none;
              border-radius: 0;
              height: 20px !important;
              line-height: 20px !important;
              padding: 0;

            }
          }
        }

        /deep/ .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 5.208vw;

          input {
            font-size: 12px;
            height: 1.042vw;
            text-align: center;
            border: none;
            border-bottom: #B3B3B3 0.052vw solid;
            outline: none;
            padding: 0;
            border-radius: 0;
          }
        }

        /deep/ .el-input__prefix {
          display: none !important;
        }

        /deep/ .el-input__suffix {
          display: none !important;
        }
      }

      .btn {
        width: 4.063vw;
        height: 1.875vw;
        background: #E8556F;
        border-radius: 0.208vw;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 1.563vw;

        img {
          width: 0.781vw;
          height: 0.781vw;
          margin-right: 0.26vw;
        }

        span {
          font-size: 0.833vw;
          font-family: PingFangSC;
          font-weight: bold;
          color: #FFFFFF;
        }
      }

      .new {
        position: absolute;
        margin-right: 0;
        right: 0;
      }
    }
  }

  input::-webkit-input-placeholder {
    color: #aab2bd;
  }
</style>



// WEBPACK FOOTER //
// src/pages/child/register/ChildTable.vue